import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { extractDriveId } from "./helper"

const SortableItem = ({ id, onUngroup }) => {
   const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
   } = useSortable({ id: id.id })

   const style = {
      transform: CSS.Transform.toString(transform),
      transition,
   }

   return (
      <div
         ref={setNodeRef}
         style={style}
         className={`p-4 mb-2 bg-white border border-gray-200 rounded-lg flex items-center gap-4 text-sm text-gray-700
            ${isDragging ? "shadow-lg opacity-50 cursor-grabbing" : "shadow-sm opacity-100 cursor-grab"}`}
         {...attributes}
         {...listeners}
      >
         <img
            src={id.driveThumbnail || `https://drive.google.com/thumbnail?sz=w256-h100&id=${extractDriveId(
               id.fileLink
            )}`}
            alt="Image from thumbnail"
            className="max-w-36 max-h-24"
         />
         <div className="flex-1">
            <div className="font-medium max-w-[150px] break-words">
               {id.fileName}
            </div>
            <div className="text-xs text-gray-500 mt-1">{id.resolution}</div>
         </div>

         {/* Ungroup button — rendered inline so it never overflows the card.
             Pointer events are stopped so the click doesn't trigger a drag. */}
         {onUngroup && (
            <button
               type="button"
               onPointerDown={(e) => e.stopPropagation()}
               onClick={(e) => { e.stopPropagation(); onUngroup(id.id); }}
               className="shrink-0 px-3 py-1.5 text-xs font-semibold text-sky-700 bg-sky-100 hover:bg-sky-200 active:bg-sky-300 rounded-lg shadow-sm transition-colors"
            >
               Ungroup
            </button>
         )}
      </div>
   )
}

export default SortableItem
